import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { LANDING } from "@/constants/testIds";
import BrandMark from "@/components/landing/BrandMark";

const navItems = [
  { href: "#services", label: "Coverage", testId: LANDING.navServices },
  { href: "#process", label: "How it works", testId: LANDING.navProcess },
  { href: "#testimonials", label: "Clients", testId: LANDING.navTestimonials },
  { href: "#faq", label: "FAQ", testId: LANDING.navFaq },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid={LANDING.header}
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background/95 backdrop-blur-md border-b border-border"
          : "bg-background/60 backdrop-blur-sm border-b border-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-24 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid={LANDING.logoLink}
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex items-center justify-center transition-transform duration-500 group-hover:-rotate-3">
            <BrandMark size={42} variant="emblem" />
          </span>
          <span className="font-display text-xl font-bold tracking-tight">
            Key Legacy Protection
          </span>
          <span className="hidden lg:inline label-eyebrow ml-3 pl-3 border-l border-border">
            Business &amp; Group Insurance
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {navItems.map((it) => (
            <a
              key={it.href}
              href={it.href}
              data-testid={it.testId}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-200"
            >
              {it.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#quote"
            data-testid={LANDING.ctaHeaderQuote}
            className="hidden sm:inline-flex items-center gap-2 bg-primary text-primary-foreground px-5 py-2.5 rounded-md text-sm font-semibold hover:bg-[#1F1F1F] transition-colors"
          >
            Get a Quote
            <span aria-hidden>→</span>
          </a>
          <button
            type="button"
            className="md:hidden p-2 rounded-md hover:bg-secondary transition-colors"
            onClick={() => setOpen((v) => !v)}
            data-testid={LANDING.mobileMenuToggle}
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navItems.map((it) => (
              <a
                key={it.href}
                href={it.href}
                data-testid={`mobile-${it.testId}`}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-foreground py-1"
              >
                {it.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setOpen(false)}
              className="bg-primary text-primary-foreground px-5 py-3 rounded-md text-sm font-semibold text-center"
            >
              Get a Quote →
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
